// Imports
import { FormControl, Paper, TextField, Typography } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Login } from '@mui/icons-material';
import { GobikesApi } from "../../config/Apis";
import { setVendorLoginToken } from '../../features/vendorProfile';
import { saveAuthCookie } from "./AuthUtil";
import ForgotCredentials from './ForgotCredentials';
import './Login.css';

// Main app component
function LoginComponent() {

  // Refs
  const usernameRef = useRef<HTMLInputElement>(null);
  const passwordRef = useRef<HTMLInputElement>(null);
  const submitButtonRef = useRef<HTMLButtonElement>(null);

  // Local state
  const [formState, setFormState] = useState({ error: false, message: '', loading: false });
  const [forgotDialog, setForgotDialog] = useState<'forgotUsername' | 'forgotPassword' | null>(null);

  // Global state
  const dispatch = useDispatch();

  // Handle login form submission
  async function submitLoginForm(e: any) {

    // Parse input and check for errors
    e.preventDefault();
    if (!usernameRef.current || !passwordRef.current) return;
    const usernameValue = usernameRef.current.value;
    const passwordValue = passwordRef.current.value;
    if (!usernameValue || !passwordValue) {
      setFormState({ error: true, message: 'Username and password are both required!', loading: false });
      return;
    }

    // Set loading mode and try to login the user
    setFormState({ error: false, message: '', loading: true });
    const payload = { username: usernameValue, password: passwordValue };
    try {
      const { data } = await GobikesApi.post('/vendors/login', payload);
      if (data.data && data.data.token) {
        saveAuthCookie(data.data.token);
        dispatch(setVendorLoginToken(data.data.token))
      } else {
        setFormState({ error: true, message: 'An unknown error occured', loading: false })
      }
    } catch (e: any) {
      const errorMessage = (e.response && e.response.data && e.response.data.message) ? 'Error: ' + e.response.data.message : 'An error occured';
      setFormState({ error: true, message: errorMessage, loading: false })
    }
  }

  // Return DOM content
  return (
    <div id='vendor-login'>
      <Paper className='gbk-paper-login' elevation={3}>
        <Typography className='gbk-login-header'>Welcome to</Typography>
        <img className='gbk-login-logo' src='https://gobikes-prod-public.s3.ap-south-1.amazonaws.com/uploads/admin/site/d95fb648-07d3-473d-8804-bd9b72471e4f.png' alt='gowheelo-logo' />
        <Typography className='gbk-login-header'>Partner Dashboard</Typography>
        <form onSubmit={submitLoginForm}>
          <FormControl
            sx={{
              margin: { xs: '10px', md: '30px 30px' },
              width: { xs: '70%', md: '400px' }
            }}
          >

            {/* Input fields */}
            <br /><br /><br /><br />
            <TextField
              inputRef={usernameRef}
              label="Username"
              variant="outlined"
              name="username"
            />
            <br />
            <TextField
              inputRef={passwordRef}
              label="Password"
              variant="outlined"
              name="password"
              type={'password'}
            />
            <br /><br /><br />

            {/* Submit button */}
            <LoadingButton
              variant='contained'
              type='submit'
              ref={submitButtonRef}
              loading={formState.loading}
              endIcon={<Login />}
              size='large'
            >
              Login
            </LoadingButton>

            {/* Forgot links */}
            <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '12px' }}>
              <Typography
                variant='body2'
                sx={{ cursor: 'pointer', color: 'primary.main', textDecoration: 'underline' }}
                onClick={() => setForgotDialog('forgotUsername')}
              >
                Forgot Username?
              </Typography>
              <Typography
                variant='body2'
                sx={{ cursor: 'pointer', color: 'primary.main', textDecoration: 'underline' }}
                onClick={() => setForgotDialog('forgotPassword')}
              >
                Forgot Password?
              </Typography>
            </div>

          </FormControl>

          {/* Error message */}
          <div className={`gbk-login-message ${formState.error ? 'error' : ''}`}>{formState.message}</div>

        </form>
      </Paper>

      {/* Forgot credentials dialogs */}
      {forgotDialog && (
        <ForgotCredentials
          open={Boolean(forgotDialog)}
          mode={forgotDialog}
          onClose={() => setForgotDialog(null)}
        />
      )}

    </div>
  )

}

export default LoginComponent;
